module.exports = __webpack_public_path__ + "media/images/ui__textArrowDownAccent-8ba5e21b7aad7a482fd2dd071f2850a8.png";